<!--
 * @FileDescription: 销售订单——待支付详情
 * @Author: ryb（作者）
 * @Date: 2020-07-16（时间）
 -->
<template>
  <div class="bill-enter-warehouse-details-page">
    <div class="bill-enter-warehouse-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col>
          <span class="a-col-title">单据单号：</span>
          <span class="a-col-value">{{ orderDetails.code }}</span>
        </a-col>
        <a-col style="margin-right: 0">
          <span class="a-col-title">单据日期：</span>
          <span class="a-col-value">{{ orderDetails.voucherDate }}</span>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">收货人：</span>
          <span class="a-col-value">{{ orderDetails.receiveName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">发货门店：</span>
          <span class="a-col-value">{{ orderDetails.outStoreName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">备注：</span>
          <span class="a-col-value">{{ orderDetails.remark }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title" style="color:#F76F14">用户备注：</span>
          <span class="a-col-value">{{ orderDetails.memberRemark }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="bill-enter-warehouse-content" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
        :scroll="{ y: tableHeight }" bordered>

      </a-table>
    </div>
    <div class="bill-enter-warehouse-footer-two" id="page-footer">
      <div class="bill-enter-warehouse-footer-left">
        <!-- <a-row>
          <a-col>
            <span class="a-col-title">配送方式：</span>
            <span class="a-col-value">送货上门</span>
          </a-col>
          <a-col>
            <span class="a-col-title">运费：</span>
            <span class="a-col-value">到付</span>
          </a-col>
          <a-col>
            <span class="a-col-title">物流公司：</span>
            <span class="a-col-value">顺丰速递</span>
            <span>8665889689244</span>
            <span class="btn-copy">复制</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="a-col-title">配送信息：</span>
            <span class="a-col-value">张三 13688888888 杭州市滨江区网商路和瑞科技园S2幢1503室</span>
          </a-col>
        </a-row> -->
      </div>
      <div class="bill-enter-warehouse-footer-right">
        <a-row>
          <a-col>
            <span class="a-col-title">折减金额：</span>
            <span class="a-col-value">
              ¥ 1000.00
            </span>
          </a-col>
          <a-col>
            <span class="a-col-title">合计：</span>
            <span class="a-col-value a-col-order-price">
              ¥<span class="order-price">1000.00</span>
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="a-col-title">支付方式和金额：</span>
            <span class="a-col-value">微信 <span style="color:#F76F14">¥ 5100.00</span></span>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 底部按钮组件 -->
    <public-footer ref="footer" :buttonList="buttonList" @onClickButton="onClickButton"></public-footer>
    <!-- 审核弹窗 -->
    <red-dashed ref="reddashed" @onConfirmOrder="onConfirmOrder"></red-dashed>
  </div>
</template>
<script>
import redDashed from "@/components/module/redDashed.vue";
import publicFooter from "@/components/module/publicFooter.vue";
import { getListSalesOrderMallInfoById } from "@/utils/cloudstoreApi";
import { operatePass } from "@/utils/api";
export default {
  name: "billEnterWarehouse",
  components: {
    publicFooter,
    redDashed
  },
  data() {
    return {
      status: null,
      orderDetails: {},
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          title: "商品名称",
          dataIndex: "productName",
          ellipsis: true,
        },
        {
          title: "商品编号",
          dataIndex: "productCode",
          ellipsis: true,
        },
        {
          title: "规格",
          ellipsis: true,
          dataIndex: "productSpecification",
        },
        {
          title: "型号",
          ellipsis: true,
          dataIndex: "productModel",
        },
        {
          title: "单位",
          ellipsis: true,
          dataIndex: "productUnitName",
          scopedSlots: { customRender: "productUnitName" },
        },
        {
          title: "数量",
          ellipsis: true,
          align: "right",
          dataIndex: "productTotalCount",
        },
        {
          title: "售价",
          ellipsis: true,
          align: "right",
          dataIndex: "price",
        },
        {
          title: "金额",
          ellipsis: true,
          align: "right",
          dataIndex: "amountCount",
        },
      ],
      buttonList: [
        {
          id: 7,
          text: "打印",
          templateType: 101,
        },
        {
          id: 101,
          text: "审核拒绝",
          class: "ant-btn-color"
        },
        {
          id: 102,
          text: "审核通过且过账",
          class: "ant-btn-primary"
        },
      ],
      dataSource: [],
      tabIndex: null,
      tableHeight: 0,
      formData: {},
      dataDetails: {},
      urlList: {},
    };
  },
  activated() {
    this.status = this.$route.query.type;
    this.init();
  },
  methods: {
    init() {
      // 表格高度计算
      let _that = this;
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      let makeButton = document.getElementById("page-footer").offsetHeight;
      _that.contentHeight =
        pageHeight -
        makeTop -
        makeButton -
        header -
        breadcrumb -
        tdHeight * 1.2;
      _that.tableHeight = _that.contentHeight - tdHeight * 2;
      this.getOrderDetails();
    },
    // 获取表格数据
    getOrderDetails() {
      let params = {};
      getListSalesOrderMallInfoById(params).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.dataSource = res.result.salesOrderItemMallVOList
          this.orderDetails = res.result;
        }
      });
    },
    // 底部按钮操作回调
    onClickButton(data) {
      this.tabIndex = data.id;
      this.$refs.reddashed.show1();
    },
    // 审核拒绝回调
    onConfirmOrder(value) {
      if (this.tabIndex == 102) {
        let params = {
          code: this.orderDetails.code,
          companyStoreId: this.$store.state.shopId,
          operationData: value,
          operationType: 1,
          voucherId: this.orderDetails.id,
          voucherType: 2,
        }
        let header = {}
        let data = {}
        operatePass(params,header,data).then((res) => {
          if (res.success) {
            this.$message.success(res.logMessage);
            this.geTroughDraftList();
          } else {
            this.$message.warn(res.logMessage);
          }
        });
      } else if (this.tabIndex == 101) {
        let params = {
          code: this.orderDetails.code,
          companyStoreId: this.$store.state.shopId,
          operationData: value,
          operationType: 2,
          voucherId: this.orderDetails.id,
          voucherType: 2,
        }
        let header = {}
        let data = {}
        operatePass(params,header,data).then((res) => {
          if (res.success) {
            this.$message.success(res.logMessage);
            this.geTroughDraftList();
          } else {
            this.$message.warn(res.logMessage);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.bill-enter-warehouse-details-page {
  .bill-enter-warehouse-information {
    height: 112px;
    padding: 20px 42px 12px 42px;
    background-color: #ffffff;
    .ant-row {
      display: flex;
      align-items: center;
    }
    .ant-row-one {
      height: 32px;
      justify-content: flex-end;
    }
    .ant-row-one-two {
      height: 32px;
      justify-content: space-between;
      .ant-row-one-left {
        width: 50%;
        display: flex;
        justify-content: flex-start;
      }
      .ant-row-one-right {
        width: 50%;
        display: flex;
        justify-content: flex-end;
      }
    }
    .ant-row-two {
      height: 48px;
    }
    .ant-col {
      display: flex;
      align-items: center;
      margin-right: 60px;
    }
  }

  .bill-enter-warehouse-content {
    margin: 16px 0;
    background-color: #ffffff;
  }

  .bill-enter-warehouse-footer {
    height: 115px;
    padding: 0px 42px;
    background-color: #ffffff;
    .ant-row {
      height: 115px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .ant-col {
        height: 40px;
        display: flex;
        align-items: center;
        margin-left: 60px;
        .a-col-order-price {
          color: #f76f14;
          font-size: 16px;
          font-weight: bold;
        }
        .order-price {
          font-size: 40px;
        }
      }
    }
  }

  .bill-enter-warehouse-footer-two {
    height: 124px;
    padding: 20px 42px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    .ant-row {
      height: 42px;
      display: flex;
      align-items: center;
    }
    .bill-enter-warehouse-footer-left {
      width: 50%;
      .ant-col {
        display: flex;
        align-items: center;
        margin-right: 38px;
        .btn-copy {
          display: inline-block;
          // width: 50px;
          height: 32px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #dddddd;
          border-radius: 6px;
          margin-left: 10px;
          padding: 0 10px;
        }
      }
    }
    .bill-enter-warehouse-footer-right {
      width: 50%;
      .ant-row {
        justify-content: flex-end;
        .ant-col {
          margin-left: 60px;
          .a-col-order-price {
            color: #f76f14;
            font-size: 16px;
            font-weight: bold;
          }
          .order-price {
            font-size: 40px;
          }
        }
      }
    }
  }
}
</style>

